<template>
  <div>
    <el-steps :active="activeNumber" simple>
      <el-step v-for="(item, index) of titleArray"
      :title="item" :class="activeNumber === index + 1 ? 'active' : ''" :key="item" />
    </el-steps>
  </div>
</template>

<script>
export default {
  props: {
    activeNumber: Number,
    titleArray: Array
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
.el-steps {
  background: none;
  padding: 0;
  .el-step {
    // border-bottom: 1px solid #ebecef;
    border-bottom: 1px solid #23cc8a;

    height: 100px;
    &.active {
      position: relative;
      &::before {
        content: ' ';
        width: 0;
        height: 0;
        position: absolute;
        bottom: 0;
        // left: 30%;
        left: 3%;
        transform: translateX(-5px);
        border-style: solid;
        border-width: 0 6px 10px 6px;
        // border-color: transparent transparent #ebecef transparent;
        border-color: transparent transparent #23cc8a transparent;
      }
    }
    /deep/ .el-step__head {
      padding-right: 6px;
      &.is-finish {
        .el-step__icon {
          background: linear-gradient(135deg, #22c686 0%, #148257 100%);
        }
        &:last-child {
          background: #000;
        }
      }
      .el-step__icon {
        width: 24px;
        height: 24px;
        border: none;
        background: rgba(235, 236, 239, 1);
      }
      .el-step__icon {
        position: relative;
        width: 24px;
        height: 24px;

        &::before {
          position: absolute;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
        }
      }
    }
    &:nth-of-type(1) {
      /deep/ .el-step__icon {
        &::before {
          content: '1';
        }
      }
    }
    &:nth-of-type(2) {
      /deep/ .el-step__icon {
        &::before {
          content: '2';
        }
      }
    }
    &:nth-of-type(3) {
      /deep/ .el-step__icon {
        &::before {
          content: '3';
        }
      }
    }
    &:nth-of-type(4) {
      /deep/ .el-step__icon {
        &::before {
          content: '4';
        }
      }
    }
    &:nth-of-type(5) {
      /deep/ .el-step__icon {
        &::before {
          content: '5';
        }
      }
    }
    /deep/ .el-step__main {
      .el-step__title {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
      }
      .is-finish {
        font-weight: 600;
        color: rgba(57, 66, 89, 1);
      }
      .is-process,
      .is-wait {
        color: rgba(96, 105, 126, 1);
      }
    }
    &.is-simple {
      &:not(:last-of-type) {
        /deep/ .el-step__title {
          max-width: 70%;
        }
      }
    }
  }
}
</style>
